import requestClient from '@oscar/request';
import { notification } from '@oscar/theme';
import { APIS } from 'common/constants/endpoints';
import { Loading } from 'common/components';
import { useQuery } from 'hooks';
import React, { useEffect } from 'react';
import { useAuth } from '../../config';

const showNotification = (message: string) => {
  notification.error({
    message: `Authorization has an error`,
    description: message,
    duration: 60,
    onClose: () => {
      window.location.href = '/';
    },
  });
};

const Authorize: React.FC = () => {
  const [auth] = useAuth();
  const [queries] = useQuery();

  useEffect(() => {
    if (queries.location.hash) {
      const params = new URLSearchParams(queries.location.hash.substring(1));
      const idToken = params.get('id_token');
      if (idToken) {
        requestClient
          .request({
            url: APIS.LOGIN_AZURE,
            method: 'POST',
            data: {
              idToken,
            },
          })
          .then((res: any) => {
            if (res?.code === 1) {
              showNotification(res?.message);
            } else {
              auth.authorizeData(res.toString());
              window.location.href = '/';
            }
          })
          .catch((error: any) => {
            showNotification(error?.message);
          });
      } else {
        window.location.href = '/';
      }
    }
  }, [queries.location.hash]);

  return <Loading />;
};

export default Authorize;
